var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sub-main take-place column actualities"},[_c('div',{staticClass:"sub-nav-white row"},_vm._l((_vm.menu),function(link,key){return _c('router-link',{key:key,staticClass:"item",attrs:{"to":{ name: link.name }}},[_vm._v("\n\t\t\t"+_vm._s(link.label)+"\n\t\t")])}),1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e9daefd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Actualities/IndexActualities.vue
// module id = null
// module chunks = 